<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-SolutionStatusTest-Title" slot="header">{{ $t('solutionStatusTestDialogTitle') }}
    <p :class="description.class">
      {{ $t(description.text) }}
      <u>
        <a :href="support.href" :target="support.target">{{ $t(support.text) }}</a>
      </u>.
    </p>
    </span>

    <el-form
      :model="data"
      @submit.native.prevent="triggerTest"
      id="testform"
      label-position="left"
      ref="data">
      <el-form-item
        :error="errors.has('account') ? $t('solutionStatusTestInputAccountError') : ''"
        :label="$t('solutionStatusTestInputAccountLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('account')"
        data-qa="Dialog-SolutionStatusTestAccount-Item">
        <el-input
          :disabled="true"
          data-qa="Dialog-SolutionStatusTestAccount-Input"
          name="account"
          required
          type="email"
          v-model="data.SolutionAccount"
          v-validate="{ rules: { required: true} }">
        </el-input>
      </el-form-item>

      <el-form-item
        :error="errors.has('password') ? $t('solutionStatusTestInputPasswordError') : ''"
        :label="$t('solutionStatusTestInputPasswordLabel')"
        :label-width="labelWidth"
        :show-message="errors.has('password')"
        data-qa="Dialog-SolutionStatusTestPassword-Item">
        <el-input
          clearable
          data-qa="Dialog-SolutionStatusTestPassword-Input"
          name="password"
          required
          type="password"
          v-model="data.SolutionPassword"
          v-validate="{ rules: { required: true} }">
        </el-input>
      </el-form-item>
      <el-form-item
        :error="errors.has('recipients') ? 'error' : ''"
        :label="$t(recipients.label)"
        :label-width="labelWidth"
        :show-message="false"
        data-qa="Dialog-SolutionStatusTestRecipients-Item">
        <el-input
          clearable
          :autosize="{ minRows: 3}"
          :data-vv-as="$t(recipients.label)"
          name="recipients"
          required
          placeholder="example1@email.com,example2@email.com"
          type="textarea"
          v-model="data.RecipientList"
          v-validate="'required|emails'">
        </el-input>
        <p class="help is-danger">{{ errors.first('recipients') }}</p>
        <span>{{ $t(recipients.tips) }}</span>
      </el-form-item>
    </el-form>

    <span slot="actions">
      <el-button
        @click="closePopup"
        class="btn-close"
        data-qa="Dialog-SolutionStatusTest-Button-Close"
        type="text">
        {{ $t('solutionStatusTestDialogButtonCloseText') }}
      </el-button>
      <el-button
        @click="triggerTest"
        :disabled="loading || errors.any()"
        :loading="loading"
        data-qa="Dialog-SolutionStatusTest-Button-Save"
        type="warning">
        {{ $t('solutionStatusTestDialogButtonOKText') }}
      </el-button>
    </span>
  </hamv-dialog>
</template>

<script>
  import main from './SolutionStatusTest.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './SolutionStatusTest.scss'
</style>



// WEBPACK FOOTER //
// SolutionStatusTest.vue?05904924